import React from "react";
import PropTypes from "prop-types";
import { Button, ButtonPurpose, ButtonSize } from "shared/Button";
import EditIcon from "shared/assets/Edit_Icon.svg";
import formatDate from "shared/@utils/formatDate";
import styles from "./AssignedAudioRow.module.css";

function TrashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  );
}

function DragHandle() {
  return (
    <div className={styles.dragHandle} aria-label="Drag to reorder">
      <div className={styles.dragLine} />
      <div className={styles.dragLine} />
      <div className={styles.dragLine} />
    </div>
  );
}

function AssignedAudioRow({
  thumbnail,
  title,
  date,
  speaker,
  episodePart,
  onRemove,
  showRemove,
  draggable,
  onEdit,
  removeAriaLabel,
}) {
  const hasDetailFields = !!(date || speaker || episodePart);

  return (
    <div className={styles.row}>
      <img className={styles.thumbnail} src={thumbnail} alt={title} />

      <div
        className={[styles.meta, !hasDetailFields ? styles.metaCompact : ""]
          .filter(Boolean)
          .join(" ")}
      >
        <span className={styles.title}>{title}</span>
        {date && <span className={styles.date}>{formatDate(date, "M/DD/YYYY")}</span>}
        {speaker && <span className={styles.speaker}>{speaker}</span>}
        {episodePart && (
          <span className={styles.episodePart}>{episodePart}</span>
        )}
      </div>

      <div className={styles.actions}>
        {showRemove && (
          <button
            className={styles.deleteButton}
            onClick={onRemove}
            aria-label={removeAriaLabel}
          >
            <TrashIcon />
          </button>
        )}
        {onEdit && (
          <Button
            purpose={ButtonPurpose.primary}
            size={ButtonSize.small}
            className={styles.editButton}
            onClick={onEdit}
            icon={
              <span className={styles.editIconWrap}>
                <img src={EditIcon} alt="" className={styles.editIcon} />
              </span>
            }
          >
            Edit
          </Button>
        )}
        {draggable && <DragHandle />}
      </div>
    </div>
  );
}

AssignedAudioRow.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  speaker: PropTypes.string,
  episodePart: PropTypes.string,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool,
  draggable: PropTypes.bool,
  onEdit: PropTypes.func,
  removeAriaLabel: PropTypes.string,
};

AssignedAudioRow.defaultProps = {
  date: null,
  speaker: null,
  episodePart: null,
  onRemove: () => {},
  showRemove: true,
  draggable: false,
  onEdit: null,
  removeAriaLabel: "Remove audio",
};

export default AssignedAudioRow;
